/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Box } from '@mui/material';

import { TranscriptSentence } from './TranscriptSentence';

export interface TranscriptSentencesProps {
  sentences: any;
  playedSeconds: number;
  fillerWords?: string[];
  onSeekTo: (value: number) => void;
  userScrolled: boolean;
  onSetUserScrolled: (value: boolean) => void;
  activeTranscription: number;
}

export const TranscriptSentences = ({
  sentences,
  playedSeconds,
  fillerWords,
  onSeekTo,
  userScrolled,
  onSetUserScrolled,
  activeTranscription,
}: TranscriptSentencesProps) => {
  const sentenceRefs = useRef<Record<number, HTMLDivElement>>({});
  const containerRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (activeIndex && !userScrolled) {
      sentenceRefs?.current?.[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [activeIndex, userScrolled]);

  const handleUserScroll = useCallback(() => {
    onSetUserScrolled(true);
  }, [onSetUserScrolled]);

  useEffect(() => {
    const container = containerRef.current;
    container?.addEventListener('wheel', handleUserScroll);
    return () => container?.removeEventListener('wheel', handleUserScroll);
  }, [handleUserScroll]);

  const addTranscriptSentenceRef = useCallback(
    (ref: HTMLDivElement) => (sentenceRefs.current[Object.keys(sentenceRefs.current).length + 1] = ref),
    [sentenceRefs],
  );

  return (
    <Box ref={containerRef}>
      {sentences?.map((sentence: any, index: number) => {
        // Wrap filler words with <span>{fillerWord}</span> to be able to style them
        let formattedSentence = sentence.text;
        const activeSentence =
          playedSeconds >= Number(sentence?.start) / 1000 && playedSeconds < Number(sentence?.end) / 1000;

        if (activeTranscription === 0) {
          fillerWords?.forEach((word) => {
            formattedSentence = formattedSentence.replace(new RegExp(`\\b${word}\\b`, 'g'), `<span>${word}</span>`);
          });
        }

        return (
          <TranscriptSentence
            key={index}
            active={activeSentence}
            startTime={sentence.start}
            formattedSentence={formattedSentence}
            index={index}
            sentence={sentence}
            onSetActiveIndex={setActiveIndex}
            ref={addTranscriptSentenceRef}
            onSeekTo={activeTranscription !== 3 ? onSeekTo : undefined}
            activeTranscription={activeTranscription}
          />
        );
      })}
    </Box>
  );
};
